import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	serviceRequestManagementTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-title',
		defaultMessage: 'Service request management',
		description: 'Title text of the service request management setting',
	},
	serviceRequestManagementDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-description',
		defaultMessage: `Streamline your request management workflow with a dedicated service request queue that helps you deliver great service experiences.
            <a target="_blank" href="{href}">Learn more about service requests</a>.`,
		description:
			'Description that explains the affects of service request management. {href} contains the URL to the help article, it does not need translation',
	},
	serviceRequestManagementDescriptionForIph: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-description-for-iph',
		defaultMessage: `Streamline your request management workflow with a dedicated service request queue that helps you deliver great service experiences.
            {learnMoreLink}`,
		description:
			'Description that explains the affects of service request management. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	serviceRequestManagementLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-management-learn-more',
		defaultMessage: 'Learn more about service requests.',
		description: 'Text used in service request management learn more link',
	},
	serviceRequestDetailsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-details-title',
		defaultMessage: 'Service request management features',
		description: 'Text used in service request management details header',
	},
	serviceRequestDetail1: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.service-request-detail-1',
		defaultMessage: "Dedicated service request queue in your project's sidebar",
		description: 'Bullet point 1 of service request management details',
	},
	incidentManagementTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-title',
		defaultMessage: 'Incident management',
		description: 'Title text of the incident management setting',
	},
	incidentManagementDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-description',
		defaultMessage: `
            <p>
                Enable your agents to respond fast when an incident occurs so they can restore disrupted services and fix vulnerabilities.
                <a target="_blank" href="{href}">Learn more about incident management</a>.
            </p>
            <p>To access all incident management features, make sure Services, On-Call and Alerts are enabled.</p>`,
		description:
			'Description that explains the affects of incident management. {href} contains the URL to the help article, it does not need translation',
	},
	incidentManagementDescriptionForInProductHelp: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-description-for-in-product-help',
		defaultMessage:
			'Enable your agents to respond fast when an incident occurs so they can restore disrupted services and fix vulnerabilities.' +
			' {learnMoreLink} {br}' +
			'To access all incident management features, make sure Services, On-Call and Alerts are enabled.',
		description:
			'Description that explains the affects of incident management. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	incidentManagementLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-learn-more',
		defaultMessage: 'Learn more about incident management.',
		description: 'Text used in incident management learn more link',
	},
	incidentManagementDetailsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-details-title',
		defaultMessage: 'Incident management features',
		description: 'Text used in incident management details header',
	},
	incidentManagementDetail1: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-1',
		defaultMessage:
			'Customizable on-call schedules, routing rules, and escalation policies to handle alerts based on source and urgency',
		description: 'Bullet point 1 of incident management details',
	},
	incidentManagementDetail2: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-2',
		defaultMessage:
			'Incident timeline, conference calls and chat tools for real-time updates and collaboration',
		description: 'Bullet point 2 of incident management details',
	},
	incidentManagementDetail3: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.incident-management-detail-3',
		defaultMessage:
			'Incident notification policies based on user preferences, with alerts by email, voice call, SMS, or push notification',
		description: 'Bullet point 3 of incident management details',
	},
	problemManagementTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-title',
		defaultMessage: 'Problem management',
		description: 'Title text of the problem management setting',
	},
	problemManagementDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-description',
		defaultMessage: `
          <p>
            Help your team prevent recurring incidents and service disruptions with tools that allow them to discover the potential cause of service vulnerabilities.
            <a target="_blank" href="{href}">Learn more about problem management</a>.
          </p>
          <p>To access all problem management features, make sure Services is enabled.</p>`,
		description:
			'Description that explains the affects of problem management. {href} contains the URL to the help article, it does not need translation',
	},
	problemManagementDescriptionForInProductHelp: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-description-for-in-product-help',
		defaultMessage:
			'Help your team prevent recurring incidents and service disruptions with tools that allow them to discover the potential cause of service vulnerabilities.' +
			'{learnMoreLink} {br}' +
			'To access all problem management features, make sure Services is enabled.',
		description:
			'Description that explains the affects of problem management. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	problemManagementLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-learn-more',
		defaultMessage: 'Learn more about problem management.',
		description: 'Text used in problem management learn more link',
	},
	problemManagementDetailsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-details-title',
		defaultMessage: 'Problem management features',
		description: 'Text used in problem management details header',
	},
	problemManagementDetail1: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-1',
		defaultMessage: 'Problem logging for post-incident reviews',
		description: 'Bullet point 1 of problem management details',
	},
	problemManagementDetail2: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-2',
		defaultMessage: 'Root-cause investigation workflows',
		description: 'Bullet point 2 of problem management details',
	},
	problemManagementDetail3: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.problem-management-detail-3',
		defaultMessage: 'Incident grouping and linking',
		description: 'Bullet point 3 of problem management details',
	},
	changeManagementTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-title',
		defaultMessage: 'Change management',
		description: 'Title text of the change management setting',
	},
	changeManagementDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-description',
		defaultMessage: `
            <p>
                Speed up service delivery and minimize deployment risk by allowing your team to flag, review, and approve changes before they can impact your services.
                <a target="_blank" href="{href}">Learn more about change management</a>.
            </p>
            <p>To access all change management features, make sure Services is enabled.</p>`,
		description:
			'Description that explains the affects of change management. {href} contains the URL to the help article, it does not need translation',
	},
	changeManagementDescriptionForInProductHelp: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-description-for-in-product-help',
		defaultMessage:
			'Speed up service delivery and minimize deployment risk by allowing your team to flag, review, and approve changes before they can impact your services.' +
			'{learnMoreLink} {br}' +
			'To access all change management features, make sure Services is enabled.',
		description:
			'Description that explains the affects of problem management. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	changeManagementLearnMore: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-learn-more',
		defaultMessage: 'Learn more about change management.',
		description: 'Text used in change management learn more link',
	},
	changeManagementDetailsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-details-title',
		defaultMessage: 'Change management features',
		description: 'Text used in change management details header',
	},
	changeManagementDetail1: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-1',
		defaultMessage: 'Automated risk assessments and low-risk deployments',
		description: 'Bullet point 1 of change management details',
	},
	changeManagementDetail2: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-2',
		defaultMessage: 'Advanced approval workflows',
		description: 'Bullet point 2 of change management details',
	},
	changeManagementDetail3: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-detail-3',
		defaultMessage: 'Integrations with CI/CD tools for affected service and deployment tracking',
		description: 'Bullet point 3 of change management details',
	},
	postIncidentReviewsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-title',
		defaultMessage: 'Post-incident reviews',
		description: 'Text used in post incident reviews header',
	},
	postIncidentReviewsDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-description',
		defaultMessage: `
                Document and share learnings from an incident so that it doesn’t happen again.
                <a target="_blank" href="{href}">Learn more about post-incident reviews</a>.
            </p>`,
		description:
			'Description that explains what post incident reviews are. {href} contains the URL to the help article, it does not need translation',
	},
	postIncidentReviewsDescriptionForInProductHelp: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.post-incident-reviews-description-for-in-product-help',
		defaultMessage:
			'Post-incident reviews help you understand the causes and impacts of incidents so that you can reduce the chance of the incident happening again. {learnMoreLink}',
		description:
			'Description that explains what post incident reviews are. {learnMoreLink} will be replace by a button, it does not need translation',
	},
	learnMoreAboutPostIncidentReviews: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.learn-more-about-post-incident-reviews',
		defaultMessage: 'Learn more about post-incident reviews.',
		description: 'Text used in change management learn more link',
	},
	changeManagementAutomation1: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-automation-1',
		defaultMessage:
			'When a change request is created → then attach the default change management form',
		description: 'Bullet point 1 for change management automations',
	},
	changeManagementAutomation2: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.change-management-automation-2',
		defaultMessage:
			'When a deployment is completed, failed or canceled → then transition request accordingly',
		description: 'Bullet point 2 for change management automations',
	},
	premiumLozenge: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.practices-features.tile.premium-lozenge',
		defaultMessage: 'Premium',
		description: 'Lozenge label that indicates a feature is a premium plan feature',
	},
});
